import { useSearchParams } from 'react-router-dom';

const withRouter = WrappedComponent => props => {
    const [searchParams] = useSearchParams();

    return (
        <WrappedComponent
            {...props}
            searchParams={searchParams}
        />
    );
};

export default withRouter;